export const COnboardingCreateTeenContactInfo = "onboardingCreateTeenContactInfo" as const;

export const CreateTeenContactInfoFormFields = {
    EMAIL: 'email',
    PHONE: 'phoneNumber',
    SKIP_CONTACT_INFO: 'skipContactInfo'
} as const;